module.exports = __webpack_public_path__ + "22d317b804ea2b717fe92f7bf79ff786.png";